import { Popover, PopoverGroup } from "@headlessui/react";
import { BlocksProvider } from "@grapesjs/react";

import "./BlockManager.scss";
import CustomPopover from "./CustomPopover.jsx";

const BlockManager = () => {
  return (
    <BlocksProvider>
      {({ mapCategoryBlocks, dragStart, dragStop }) => {
        const categories = Array.from(mapCategoryBlocks.keys());
        return (
          <PopoverGroup id="blocks">
            {categories.map((category) => {
              const categoryBlocks = mapCategoryBlocks.get(category);
              return (
                <Popover key={category}>
                  {({ open, close }) => (
                    <CustomPopover
                      key={`${category}-popover`}
                      open={open}
                      close={close}
                      category={category}
                      categoryBlocks={categoryBlocks}
                      dragStart={dragStart}
                      dragStop={dragStop}
                    />
                  )}
                </Popover>
              )
            })}
          </PopoverGroup>
        );
      }}
    </BlocksProvider>
  );
};

export default BlockManager;
